import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { IEditableProps } from 'components/uiKit/Editable'
import Editable from 'components/uiKit/Editable'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldEditable: React.FC<IControlProps<IEditableProps>> = ({
  name,
  onChange,
  defaultValue,
  value,
  ...rest
}) => {
  const onChangeWrapper = useCallback(
    (value?: string | null) => onChange({ name, value }),
    [name, onChange],
  )

  return (
    <Editable
      {...rest}
      name={name}
      onChange={onChangeWrapper}
      value={value ?? (defaultValue as string)}
    />
  )
}

export default FieldEditable
